import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import logicGraphDataActions from "../../../../actions/logicGraphDataActions";

import uniqueId from 'lodash/uniqueId';
import {ReactSortable} from 'react-sortablejs';

import {InputEntry} from "../InputPortListUtils/InputEntry";
import ContentWithTopLabel from "../ContentWithTopLabel";
import InputWithLabel from "../InputWithLabel";
import {OverwriteDynamicPropertyCheckbox} from "../InputPortListUtils/components/OverwriteDynamicPropertyCheckbox";
import {clickedNodeAction} from "../../../../actions/clickedNodeActions";
import {AddInputButton} from "../InputPortListUtils/components/AddInputButton";
import Predicate from "../Predicate";
import {ContextPropertyModifier} from "./ContextPropertyModifier";
import defaultContextModifierOption from "./ContextPropertyModifier/defaultContextModifierOption";

const switchDefaultPredicateOption = defaultContextModifierOption;

export const InputPortList = (props) => {
    const {clickedNodeInfo} = props;

    const nodeOptions = clickedNodeInfo.extras.options;
    const contextPropertyModifierInfo = nodeOptions.contextPropertyModifierInfo;
    const hasFuncs = nodeOptions && contextPropertyModifierInfo;

    const [state, setState] = useState({
        compositeFieldName: hasFuncs ? contextPropertyModifierInfo.compositeFieldName : "",
        portList: [],
        options: {
            inputPortData: [],
            logDecisionName: null,
            contextPropertyModifierInfo: contextPropertyModifierInfo,
            id: clickedNodeInfo.options.id,
            compositeFieldName: hasFuncs ? contextPropertyModifierInfo.compositeFieldName : "",
            elementIdAutoIncrement: hasFuncs ? contextPropertyModifierInfo.elementIdAutoIncrement : 0,
            shouldOverwriteContextPropertyIfExists: hasFuncs ? contextPropertyModifierInfo.shouldOverwriteContextPropertyIfExists : true,
            shouldSuffixContextPropertyIfSplitIsUsed: hasFuncs ? contextPropertyModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed : false
        },
        predicate: {
            type: "and",
            predicates: [
                switchDefaultPredicateOption
            ],
            alwaysTrue: false
        },
        modifier: hasFuncs ? (contextPropertyModifierInfo.func ? contextPropertyModifierInfo.func : contextPropertyModifierInfo.modifier) : {
            funcName: "concat",
            funcArgs: []
        },
        elementIdAutoIncrement: hasFuncs ? contextPropertyModifierInfo.elementIdAutoIncrement : 0,
        shouldOverwriteContextPropertyIfExists: hasFuncs ? contextPropertyModifierInfo.shouldOverwriteContextPropertyIfExists : true,
        shouldSuffixContextPropertyIfSplitIsUsed: hasFuncs ? contextPropertyModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed : false
    });

    useEffect(() => {
        createList();
    }, [])

    useEffect(() => {
        createOption();
    }, [state.options.inputPortData])

    const updateProperty = (property, value) => {
        let contextPropertyModifierInfo = {...props.clickedNodeInfo}
        if (!Object.prototype.hasOwnProperty.call(contextPropertyModifierInfo.extras, "options")) {
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {};
        }
        contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {
            ...state,
            [property]: value
        };

        setState({
            ...state,
            options: {
                ...state.options,
                [property]: value
            }
        });

        if (property === "shouldOverwriteContextPropertyIfExists") {
            contextPropertyModifierInfo.extras.options.shouldOverwriteContextPropertyIfExists = value;
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.shouldOverwriteContextPropertyIfExists = value;
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.options.shouldOverwriteContextPropertyIfExists = value;
        }
        if (property === "shouldSuffixContextPropertyIfSplitIsUsed") {
            contextPropertyModifierInfo.extras.options.shouldSuffixContextPropertyIfSplitIsUsed = value;
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed = value;
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.options.shouldSuffixContextPropertyIfSplitIsUsed = value;
        }
        if (property === "compositeFieldName") {
            contextPropertyModifierInfo.extras.options.compositeFieldName = value;
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.compositeFieldName = value;
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.options.compositeFieldName = value;
        }
        props.clickedNodeAction(contextPropertyModifierInfo);
    }

    const updateOptionFieldName = (property, e) => {
        const value = e.target.value;
        state.compositeFieldName = value;
        updateProperty(property, value)
    }

    const onCheck = (e, propName) => {
        const value = e.target.checked;
        state[propName] = value
        updateProperty(propName, value)
    }

    useEffect(() => {
        updateProperty("shouldOverwriteContextPropertyIfExists", state.shouldOverwriteContextPropertyIfExists);
        onOptionsUpdate("", "", {id: -1})
    }, [state.options.shouldOverwriteContextPropertyIfExists, state.shouldOverwriteContextPropertyIfExists])

    useEffect(() => {
        updateProperty("shouldSuffixContextPropertyIfSplitIsUsed", state.shouldSuffixContextPropertyIfSplitIsUsed);
        onOptionsUpdate("", "", {id: -1})
    }, [state.options.shouldSuffixContextPropertyIfSplitIsUsed, state.shouldSuffixContextPropertyIfSplitIsUsed])

    useEffect(() => {
        updateProperty("compositeFieldName", state.compositeFieldName);
        onOptionsUpdate("", "", {id: -1})
    }, [state.options.compositeFieldName, state.compositeFieldName])

    const onOptionsUpdate = (type, value, item) => {
        let contextPropertyModifierInfo = {...props.clickedNodeInfo}

        const updatedItem = item;
        if (type === 'modifier') {
            updatedItem.modifier = value;
        }
        if (type === 'predicate') {
            updatedItem.predicate = value;
        }

        const updatedPortData = state.options.inputPortData.filter(port => port.id !== item.id ? port : item);

        if (!Object.prototype.hasOwnProperty.call(contextPropertyModifierInfo.extras, "options")) {
            contextPropertyModifierInfo.extras.options = {};
        }
        contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {
            ...state,
            inputPortData: updatedPortData
        };

        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: updatedPortData
            }
        });

        props.clickedNodeAction(contextPropertyModifierInfo);
    }

    const createList = () => {
        const engine = props.logicDataInfo
        const model = engine.getModel();
        const logicData = model.serialize();

        const clickedNodeModifierInfo = {...props.clickedNodeInfo};
        const portList = [];
        const inputPortData = clickedNodeModifierInfo.extras.options.inputPortData;


        Object.values(clickedNodeModifierInfo.ports).forEach((v, i) => {
            const predicate = JSON.parse(JSON.stringify(state.predicate));
            const modifier = JSON.parse(JSON.stringify(state.modifier));
            const values = {
                logDecisionValue: '',
                predicate: predicate,
                modifier: modifier,
                shouldOverwriteContextPropertyIfExists: props.clickedNodeInfo.options.shouldOverwriteContextPropertyIfExists,
                shouldSuffixContextPropertyIfSplitIsUsed: props.clickedNodeInfo.options.shouldSuffixContextPropertyIfSplitIsUsed,
                compositeFieldName: props.clickedNodeInfo.options.compositeFieldName,
            };

            if (typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in) {
                values.logDecisionValue = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].logDecisionValue : '';
                values.compositeFieldName = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].compositeFieldName : true;
                values.shouldOverwriteContextPropertyIfExists = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].shouldOverwriteContextPropertyIfExists : true;
                values.shouldSuffixContextPropertyIfSplitIsUsed = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].shouldSuffixContextPropertyIfSplitIsUsed : true;
                values.predicate = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].predicate : predicate;
                values.modifier = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].modifier : modifier;
            }

            const createData = {
                parentID: clickedNodeModifierInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Modifier',
                branchName: '',
                index: 0,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: values.logDecisionValue,
                predicate: values.predicate,
                modifier: values.modifier,
                shouldOverwriteContextPropertyIfExists: values.shouldOverwriteContextPropertyIfExists,
                shouldSuffixContextPropertyIfSplitIsUsed: values.shouldSuffixContextPropertyIfSplitIsUsed,
                compositeFieldName: values.compositeFieldName,
                in: v.options.in
            }

            if (v.connection) {
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if (link.sourcePort === v.options.id) {
                        nodeID = link.target;
                    }
                    if (link.targetPort === v.options.id) {
                        nodeID = link.source;
                    }
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0]
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i
                portList.push(createData);
            } else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);
        inputPortList.forEach((v, i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });

        state.portList = newPortList;
        state.options.inputPortData = inputPortData !== undefined ? inputPortData : [];
        state.compositeFieldName = clickedNodeModifierInfo.extras.options.compositeFieldName;
        state.shouldOverwriteContextPropertyIfExists = clickedNodeModifierInfo.extras.options.shouldOverwriteContextPropertyIfExists;
        state.shouldSuffixContextPropertyIfSplitIsUsed = clickedNodeModifierInfo.extras.options.shouldSuffixContextPropertyIfSplitIsUsed;
    }

    const createOption = () => {
        const inputPortData = Object.values({...state.options.inputPortData});

        const options = {...state.options};
        options.inputPortData = inputPortData;
        options.logDecisionName = props.clickedNodeInfo.extras.options.logDecisionName;
        options.shouldOverwriteContextPropertyIfExists = props.clickedNodeInfo.extras.options.shouldOverwriteContextPropertyIfExists;
        options.shouldSuffixContextPropertyIfSplitIsUsed = props.clickedNodeInfo.extras.options.shouldSuffixContextPropertyIfSplitIsUsed;
        options.compositeFieldName = props.clickedNodeInfo.extras.options.compositeFieldName;

        const logicGraphData = {
            options: options,
            portList: state.portList,
            id: props.clickedNodeInfo.options.id,
            shouldOverwriteContextPropertyIfExists: props.clickedNodeInfo.options.shouldOverwriteContextPropertyIfExists,
            shouldSuffixContextPropertyIfSplitIsUsed: props.clickedNodeInfo.options.shouldSuffixContextPropertyIfSplitIsUsed,
            compositeFieldName: props.clickedNodeInfo.options.compositeFieldName
        }
        props.logicGraphDataActions(logicGraphData);
    }

    const removeInputPort = (item) => {
        const portList = state.options.inputPortData;
        const newInputPortList = portList.filter(port => port.id !== item.id);
        for (let i = 0; i < newInputPortList.length; i++) {
            newInputPortList[i].id = i;
        }
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: newInputPortList
            }
        });
    }

    const addModifier = () => {
        const inputPortData = state.options.inputPortData;
        const newModifier = {
            predicate: state.predicate,
            modifier: state.modifier,
            alwaysTrue: false,
            logDecisionValue: '',
            id: inputPortData.length,
            edit: false,
        }
        inputPortData.push(newModifier)

        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: inputPortData
            },
        });
    }

    const editInputButton = (item) => {
        const setEditValue = editModifierButton(state.options.inputPortData, item);
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: setEditValue
            }
        });
    }

    function editModifierButton(portListData, item) {
        const portList = Object.assign({}, portListData);
        return Object.values(portList).map((v) => {
            if (v.id === item.id)
                v.edit = !v.edit;
            return v;
        });
    }

    const inputHandle = (event, item, name) => {
        let process = false;
        const portList = {...state.options.inputPortData};
        const setInputData = Object.values(portList).map((v) => {
            if (v.id === item.id) {
                if (name === 'logDecisionValue' && v.logDecisionValue !== event.target.value) {
                    v.logDecisionValue = event.target.value;
                    process = true;
                }
            }
            return v;
        });
        if (process) {
            setState({
                ...state,
                options: {
                    ...state.options,
                    inputPortData: setInputData
                }
            });
        }
    }

    const defaultPort = (data) => {
        if (data.length === 0) return [];
        return data.map((val) => {
            return (
                <InputEntry value={val} key={val.id}
                            removePort={removeInputPort}
                            inputHandle={inputHandle}
                            editButton={editInputButton}>
                    <Predicate updateOptions={(predicate) => onOptionsUpdate("predicate", predicate, val)}
                               predicate={val.predicate}
                               hasInputCount
                               predicateBlockType={"context_modifier"}
                    />
                    <ContextPropertyModifier
                        updateOptions={(funcName) => onOptionsUpdate("modifier", funcName, val)}
                        modifier={val.modifier}
                        updateProperty={updateProperty}
                        predicateBlockType={"context_modifier"}
                    />
                </InputEntry>
            )
        })
    }

    const groupCreate = () => {
        const portListData = state.options.inputPortData;

        const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
        return (
            <ReactSortable key="static"
                           animation={150}
                           handle='.drag-handle'
                           group={'default_group' + uniqueId()}
                           pull={true}
                           put={true}

                           list={portListData}
                           setList={(newState) => {
                               if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                                   const newPortList = [...newState];
                                   newPortList.forEach((val, key) => {
                                       val.id = key;
                                       return val;
                                   });
                                   setState({
                                       ...state,
                                       options: {
                                           ...state.options,
                                           inputPortData: newPortList
                                       }
                                   });
                               }
                           }}
                           className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
            >
                {defaultPort(portListData)}
            </ReactSortable>
        )
    }

    return (
        <div>
            <ContentWithTopLabel label="Field name">
                <InputWithLabel
                    label="New Context property name:"
                    handleChange={e => updateOptionFieldName('compositeFieldName', e)}
                    value={state.compositeFieldName}
                />
                <OverwriteDynamicPropertyCheckbox
                    isChecked={state.shouldOverwriteContextPropertyIfExists}
                    onCheck={onCheck}
                    name={"shouldOverwriteContextPropertyIfExists"}
                    label={"Should Overwrite Context Property If Exists"}
                />
                <OverwriteDynamicPropertyCheckbox
                    isChecked={state.shouldSuffixContextPropertyIfSplitIsUsed}
                    onCheck={onCheck}
                    name={"shouldSuffixContextPropertyIfSplitIsUsed"}
                    label={"Should Suffix Context Property If Split Is Used"}
                />
            </ContentWithTopLabel>
            <ContentWithTopLabel label="Modifiers"/>
            <div className="node-input-list">
                {
                    state.portList && groupCreate()
                }
                <AddInputButton onClick={addModifier}/>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}

export default connect(mapStateToProps, {logicGraphDataActions, clickedNodeAction})(InputPortList);
